export function canScan(pathname: string) {
  if (
    pathname.includes("/custom-product") ||
    pathname.includes("/basket-product") ||
    pathname.includes("/weight-product") ||
    pathname.includes("/shopper-name") ||
    pathname.includes("/discount-order") ||
    pathname.includes("/invoice") ||
    pathname.includes("/email") ||
    pathname.includes("/billing") ||
    pathname.includes("/cash") ||
    pathname.includes("/card") ||
    pathname.includes("/credit") ||
    pathname.includes("/mobilepay") ||
    pathname.includes("/swish") ||
    pathname.includes("/print") ||
    pathname.includes("/stampcard")
  ) {
    return false;
  }

  return true;
}
